import styled from 'styled-components';

export const RealtimeLabel = styled.div`
  color: ${props => props.theme.primaryFontColor};
  font-size: 1.25em;
  line-height: 1;
  font-weight: 600;
`;

export const ScheduledLabel = styled.div`
  color: ${props => props.theme.primaryFontColor};
  font-size: 0.8em;
  line-height: 0.85;
`;

export const DangerLabel = styled.div`
  font-size: 0.8em;
  color: ${props => props.theme.dangerColor};
  line-height: 0.85;
`;

export const ScheduledTime = styled.div`
  color: ${props => props.theme.primaryFontColor};
  font-size: 1em;
  line-height: 1.1;
`;

export const CanceledTime = styled.div`
  font-size: 0.8em;
  line-height: 1.1;
  color: ${props => props.theme.dangerColor};
`;
